import { CloseOutlined, PlusCircleOutlined, SmileOutlined } from '@ant-design/icons'
import { getOperationName } from '@apollo/client/utilities'
import { Button, Tag } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  GetUserHobbiesDocument,
  RequestedUserHobbyFragment,
  useGetUserHobbiesQuery,
  useUserHobbyUpdateMutation,
} from '@/generated/graphql'

import { UserInfoSectionLayout } from '../user-info-section-layout/user-info-section-layout.component'
import { UserInfoProps } from '../user-info.interface'
import s from '../user-info.module.less'
import { UserInfoHobbyModal } from './user-info-hobby-modal.component'

export const UserInfoHobbyInner: React.FC<
  UserInfoProps & { hobbies: RequestedUserHobbyFragment[]; bodyStyle?: any }
> = ({ userId, readonly, hobbies, bodyStyle }) => {
  const [userHobbyUpdate] = useUserHobbyUpdateMutation({
    refetchQueries: [getOperationName(GetUserHobbiesDocument)!],
  })

  return (
    <div style={bodyStyle}>
      <div className={s.hobbyAndInterests}>
        {hobbies.map((hobby) => {
          return (
            <div className={s.hobby} key={hobby.hobbyId}>
              <Tag
                style={{
                  fontSize: 16,
                  borderRadius: 16,
                  backgroundColor: 'unset',
                }}
              >
                <div style={{ padding: 4, display: 'flex', alignItems: 'center' }}>
                  {hobby.name}
                  {!readonly && (
                    <CloseOutlined
                      style={{
                        color: '#65676b',
                        marginLeft: 8,
                        cursor: 'pointer',
                        fontSize: 12,
                      }}
                      onClick={() =>
                        userHobbyUpdate({
                          variables: {
                            userId,
                            hobbyId: hobby.hobbyId,
                          },
                        })
                      }
                    />
                  )}
                </div>
              </Tag>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export const UserInfoHobby: React.FC<UserInfoProps> = ({ userId, viewerId, readonly }) => {
  const { t } = useTranslation()

  const [visible, setVisible] = React.useState(false)

  const { data } = useGetUserHobbiesQuery({
    variables: {
      userId,
      hobbyPagination: {
        last: 100,
      },
    },
  })

  const hobbies = data?.user.hobbies?.edges.map(({ node }) => node) || []

  if (hobbies.length === 0 && readonly) {
    return null
  }

  return (
    <UserInfoSectionLayout
      title={t('user.info.hobbies.title')}
      icon={<SmileOutlined />}
      showActions={true}
      actions={
        !readonly && (
          <Button
            className={s.hobbyAddButton}
            icon={<PlusCircleOutlined style={{ color: '#48bbb5' }} />}
            type='text'
            size='large'
            onClick={() => setVisible(true)}
          >
            {t('user.info.hobby.addTag')}
          </Button>
        )
      }
    >
      {hobbies.length > 0 ? (
        <UserInfoHobbyInner userId={userId} viewerId={viewerId} readonly={readonly} hobbies={hobbies} />
      ) : (
        <span>来添加第一个爱好吧～</span>
      )}
      <UserInfoHobbyModal visible={visible} setVisible={setVisible} userId={userId} userHobbies={hobbies} />
    </UserInfoSectionLayout>
  )
}
